<template>
  <div>
    <Toggletip
      :width="500"
      activator-label="display more information about Research Questions"
      button-component="ResearchDirectionsQuestionToggletipButton"
    >
      <div class="d-flex flex-column" aria-live="polite">
        <h4 class="d-flex align-center py-2">
          <ResearchDirectionsQuestionMarkIcon
            id="researchDirectionsIconTooltipText"
            question-mark-color="var(--v-inverted-base)"
            class="mr-2 focused--text"
            focusable="false"
            aria-hidden="true"
          />
          <span>What are research questions and what are their purpose?</span>
        </h4>
        <p>
          Questions are suggested by researchers in the community and approved
          by the journal editorial board. Academic researchers are encouraged to
          contribute relevant content to address these questions and participate
          in the discussion. Research Directions will show the evolution of the
          research project, starting with the question and highlighting the
          connections between related items, while giving equal prominence to
          all research outputs.
        </p>
      </div>
    </Toggletip>
  </div>
</template>

<script>
import { mapState } from "vuex";

import ResearchDirectionsQuestionMarkIcon from "~/components/research-directions/icons/ResearchDirectionsQuestionMarkIcon.vue";
import Toggletip from "~/components/page/components/toggletip/Toggletip.vue";

export default {
  name: "ResearchDirectionsQuestionsTooltip",
  components: {
    ResearchDirectionsQuestionMarkIcon,
    Toggletip,
  },
  data() {
    return {
      showTooltip: false,
    };
  },
  computed: {
    ...mapState({
      images: (state) => state.theme.images.researchDirections,
    }),
  },
};
</script>

<style scoped>
.v-tooltip__content {
  pointer-events: initial;
}
</style>
